import { SessionStorage } from '@ztechapps/common.utils'
import { useMemo } from 'react'

export const useAllSessionStorage = () => {
  return useMemo(() => new SessionStorage(), [])
}
